import React from 'react';
import { FadeIn } from './FadeIn';
import { Brain, Moon, Smile, Zap } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    icon: <Brain className="w-8 h-8" data-id="element-140" />,
    text: 'Claridad mental que regresa de verdad'
  }, {
    icon: <Moon className="w-8 h-8" data-id="element-141" />,
    text: 'Sueño profundo y reparador'
  }, {
    icon: <Smile className="w-8 h-8" data-id="element-142" />,
    text: 'Calma que no depende de las circunstancias'
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-143" />,
    text: 'Energía sostenida sin necesitar cafeína'
  }];
  return <section className="py-20 bg-brand-forest text-white" data-id="element-144">
      <div className="max-w-6xl mx-auto px-6" data-id="element-145">
        <FadeIn data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-16 max-w-2xl mx-auto leading-tight" data-id="element-147">
            Lo que cambia cuando tu mente se desintoxica
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-148">
          {results.map((result, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-149">
              <div className="flex flex-col items-center text-center group" data-id="element-150">
                <div className="w-16 h-16 bg-white bg-opacity-10 rounded-full flex items-center justify-center text-brand-sage mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-151">
                  {result.icon}
                </div>
                <p className="font-medium text-lg px-4" data-id="element-152">{result.text}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-153">
          <div className="max-w-3xl mx-auto bg-white bg-opacity-10 rounded-full py-4 px-8 backdrop-blur-sm border border-white border-opacity-20" data-id="element-154">
            <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-brand-sage font-bold text-lg md:text-xl tracking-wide text-center" data-id="element-155">
              <span data-id="element-156">21 Días</span>
              <span className="hidden sm:inline opacity-50" data-id="element-157">|</span>
              <span data-id="element-158">30 Módulos</span>
              <span className="hidden sm:inline opacity-50" data-id="element-159">|</span>
              <span data-id="element-160">8 Intervenciones</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}